const COOKIE_NAME = "session_expiry";
const SESSION_DURATION_MS = 3 * 60 * 60 * 1000;

function setCookie(name, value, maxAgeSeconds) {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0`;
}

// Call on successful login. Sets both the JS-readable expiry value
// AND lets the browser expire the cookie itself after 3h as a backstop.
export function startSession() {
  const expiresAt = Date.now() + SESSION_DURATION_MS;
  setCookie(COOKIE_NAME, String(expiresAt), SESSION_DURATION_MS / 1000);
  return expiresAt;
}

export function getSessionExpiry() {
  const raw = getCookie(COOKIE_NAME);
  return raw ? parseInt(raw, 10) : null;
}

export function isSessionExpired() {
  const expiresAt = getSessionExpiry();
  if (!expiresAt) return true; // no cookie = no valid session
  return Date.now() >= expiresAt;
}

export function clearSession() {
  deleteCookie(COOKIE_NAME);
}